import { memo, useRef } from 'react';
import PropTypes from 'prop-types';

import Row from './Row';

import './Body.scss';

const EMPTY_ARRAY = [];

const Body = ({ statuses = EMPTY_ARRAY, isRunning = false }) => {
  const scrollRef = useRef()

  return (
    <div className="statuses__details__content">
      <div className="statuses__details__content__headers">
        <div className="statuses__details__content__headers__header statuses__details__content__headers__header--time">
          Start time
        </div>
        <div className="statuses__details__content__headers__header statuses__details__content__headers__header--status">
          Status
        </div>
        <div className="statuses__details__content__headers__header statuses__details__content__headers__header--run-time">
          Run time
        </div>
        <div className="statuses__details__content__headers__header statuses__details__content__headers__header--execution">
          Execution
        </div>
        <div className="statuses__details__content__headers__header statuses__details__content__headers__header--message">
          Message
        </div>
      </div>
      <div 
          className="statuses__details__content__body"
          ref={scrollRef}
      >
        {statuses.map(({ eId, status, startTime, component, message, endTime, payload, warnStatuses }, index) => (
          <Row 
              component={component}
              endTime={endTime}
              isRunning={isRunning}
              key={eId + status + startTime + component + index}
              message={message}
              payload={payload}
              scrollRef={scrollRef}
              startTime={startTime}
              status={status}
              warnStatuses={warnStatuses}
          />
        ))}
      </div>
    </div>
  )
}

Body.propTypes = {
  isRunning: PropTypes.bool,
  statuses: PropTypes.array
}

export default memo(Body);